import { PROBLEMS } from "@/lib/data";
import { SectionHead, SHELL, TiltCard } from "@/components/bits";

export default function Problem() {
    return (
        <section className="relative py-24 md:py-32" data-testid="problem-section">
            <SHELL>
                <SectionHead
                    index="02"
                    label="THE PROBLEM"
                    title={"CAPITAL EXISTS.\nINFRASTRUCTURE IS FRAGMENTED."}
                />
                <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-5">
                    {PROBLEMS.map((p) => {
                        const Icon = p.icon;
                        return (
                            <TiltCard key={p.num} testid={`problem-card-${p.num}`} className="h-full">
                                <div className="glass-card p-7 h-full flex flex-col group hover:border-vera-blue/40 transition-colors">
                                    <div className="flex items-start justify-between mb-10">
                                        <Icon className="w-6 h-6 text-vera-soft group-hover:text-vera-gold2 transition-colors" strokeWidth={1.5} aria-hidden="true" />
                                        <span className="font-mono text-3xl font-bold text-white/10 group-hover:text-vera-gold/30 transition-colors">{p.num}</span>
                                    </div>
                                    <h3 className="font-mono text-xs tracking-[0.25em] mb-4 text-vera-white">{p.title}</h3>
                                    <p className="text-sm text-vera-mut leading-relaxed">{p.text}</p>
                                </div>
                            </TiltCard>
                        );
                    })}
                </div>
            </SHELL>
        </section>
    );
}
